import { render, staticRenderFns } from "./iconDropHere.vue?vue&type=template&id=8a82e2d0"
import script from "./iconDropHere.vue?vue&type=script&lang=js"
export * from "./iconDropHere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports